export const SECOND_STEP_TEXT = 'Second Step' as const
export const NOTIFY_ADMINS_TEXT_HEADER = 'Admins will be notified' as const
export const NOTIFY_ADMINS_TEXT_BODY =
  `Adding Second Step® admins will grant them access to your school's
            Second Step® programs and features. We'll send them an email
            notification to let them know.` as const
export const NOTIFY_USERS_TEXT_HEADER = 'Send email notification?' as const
export const NOTIFY_USERS_TEXT_BODY =
  "Adding users will grant them access to your school's Second Step® programs. You can notify them of access now or wait until you're ready." as const
export const FAQ_LINK = ' See the FAQ on email notifications.' as const
export const NOTIFY_RADIO_LABEL_TRUE = 'Yes, send emails now' as const
export const NOTIFY_RADIO_LABEL_FALSE = "No, we'll do this later" as const
export const FAQ_LINK_URL =
  'https://support.secondstep.org/hc/en-us/articles/360017384794-I-am-a-license-administrator-What-does-that-mean-' as const
